'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.CompFaresChartWrapper', dependencies).controller('CompFaresChartWrapperController', require('./controllers/CompFaresChartWrapperController')).directive('rmCompFaresChartWrapper', require('./directives/CompFaresChartWrapperDirective'));